import React from "react";

import Card from "@material-ui/core/Card";
// import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
// import CardMedia from "@material-ui/core/CardMedia";
import IconButton from "@material-ui/core/IconButton";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
// import VisibilityIcon from "@material-ui/icons/Visibility";

// import DynamicFormContainer from "./components/dynamic-form-container";
import EventTableContainer from "./components/event-table-container";
import LastValueContainer from "./components/last-value-container";
import MapContainer from "./components/map-container";
import SunriseSunsetContainer from "./components/sunrise-sunset-container";
import TrendGraphContainer from "./components/trend-graph-container";
import TrendTableContainer from "./components/trend-table-container";
import VirtualInstrumentContainer from "./components/virtual-instrument-container";

import useDateRange from "./use-date-range";
import usePanel from "./usePanel";

// import * as Moment from "moment";
// import { extendMoment } from "moment-range";

// const moment = extendMoment(Moment);

// import { useQuery } from "@apollo/client";
// import { loader } from "graphql.macro";

// const panelState = loader("./graphql/GetPanelState.graphql");

interface Props {
  // saveEntity: any;
  entity?: any;
  widget?: any;
  // defaultValues?: any;
  arrayHelpers?: any;

  fieldName?: string;
  fieldIndex: number;
  readonly?: boolean;

  onView: any;
  onEdit: any;
  onDelete: any;
}

// TODO arrayHelpers.move on drag&drop!
function WidgetCard(props: Props) {
  const {
    // entity,
    widget,
    // arrayHelpers,
    // fieldName,
    // fieldIndex,
    readonly /*: parentReadonly*/,
    // onView,
    onEdit,
    onDelete,
  } = props;
  // const theme = useTheme() as Theme;
  // const fullScreen = false; // TODO useMediaQuery(theme.breakpoints.down("sm"));
  // const [open, setOpen] = useState(false);
  // const readonly = parentReadonly || open;

  // function handleView(event?: any) {
  //   onView(widget, event);
  // }
  function handleEdit(event?: any) {
    onEdit(widget, event);
  }
  function handleDelete(event?: any) {
    onDelete(widget, event);
  }

  // function handleClose() {
  //   setOpenEntity(null);
  //   setOpen(false);
  // }

  const headerActions = !readonly && (
    <>
      {/* {handleView && <IconButton
        aria-label="Show"
        color="primary"
        onClick={handleView}
        size="small"
      >
        <VisibilityIcon />
      </IconButton>} */}
      <IconButton
        aria-label="Edit"
        color="primary"
        onClick={handleEdit}
        size="small"
      >
        <EditIcon />
      </IconButton>
      <IconButton
        aria-label="Delete"
        color="primary"
        // onClick={() => arrayHelpers.remove(fieldIndex)}
        onClick={handleDelete}
        size="small"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
  // const interval = widget.interval ? moment.range(widget.interval) : undefined;
  // const startDate = interval ? interval.start.unix() : moment(data.durationSelect.startDate).unix();
  // const endDate = interval ? interval.end.unix() : moment(data.durationSelect.endDate).unix();
  // const interval = widget.interval;

  const { startDate, endDate } = useDateRange(widget.interval);
  const panelId = usePanel(widget.panelId);

  // const { data, error, loading } = useQuery(panelState, {
  //   variables: { panel: panelId },
  // });
  // // if (!panelId) {
  // //   return <div>No panel selected!</div>;
  // // }
  // if (loading) {
  //   return <div>Loading...</div>;
  // }
  // if (error) {
  //   console.error(error.message);
  //   return <div>Error! {error.message}</div>;
  // }
  // if (data && data.panelState) {
  //   console.log("panelState", data.panelState);
  // }

  // console.log("range: ", interval);

  let widgetType = widget.type;
  // if (!widgetType) {
  //   if (data && data.panelState) {
  //     widgetType = data.panelState.viewType;
  //     // console.log("widgetType", widgetType);
  //   }
  // }

  return (
    <Card style={{ height: "100%", width: "100%" /*overflow: "visible"*/ }}>
      <CardHeader action={headerActions} title={widget.title} />
      <CardContent style={{ height: "calc(100% - 63px)" }}>
        {/* TODO type should not be magic string (=> enum or constants) */}
        {!panelId && "No panel selected!"}
        {!!(
          panelId &&
          (widgetType === "CHART" || widgetType === "GRAPHIC")
        ) && (
          <TrendGraphContainer
            // nodes={[{ id: '56' }, { id: '57' }]}
            panelId={panelId}
            startDate={startDate}
            endDate={endDate}
            widgetStatic={readonly}
            widgetTitle={widget.title}
          />
        )}
        {!!(panelId && widgetType === "TABLE") && (
          <TrendTableContainer
            // nodes={[{ id: '56' }, { id: '57' }]}
            panelId={panelId}
            startDate={startDate}
            endDate={endDate}
            widgetStatic={readonly}
            widgetTitle={widget.title}
          />
        )}
        {!!(
          panelId &&
          (widgetType === "EVENT_LIST" || widgetType === "EVENTS")
        ) && (
          <EventTableContainer
            // nodes={[{ id: '56' }, { id: '57' }]}
            panelId={panelId}
            startDate={startDate}
            endDate={endDate}
            widgetStatic={readonly}
            widgetTitle={widget.title}
          />
        )}
        {!!(panelId && widgetType === "MAP") && (
          <MapContainer
            // nodes={[{ id: '56' }, { id: '57' }]}
            panelId={panelId}
            widgetStatic={readonly}
            widgetTitle={widget.title}
          />
        )}
        {!!(panelId && widgetType === "LAST_VALUE") && (
          <LastValueContainer
            // nodes={[{ id: '56' }, { id: '57' }]}
            nodeId={panelId}
            widgetStatic={readonly}
            widgetTitle={widget.title}
          />
        )}
        {!!(
          panelId &&
          (widgetType === "GAUGE" ||
            widgetType === "VIRTUAL_INSTRUMENT" ||
            widgetType === "VI")
        ) && (
          <VirtualInstrumentContainer
            // nodes={[{ id: '56' }, { id: '57' }]}
            nodeId={panelId}
            widgetStatic={readonly}
            widgetTitle={widget.title}
          />
        )}
        {!!(panelId && widgetType === "SUNRISE_SUNSET") && (
          <SunriseSunsetContainer
            // nodes={[{ id: '56' }, { id: '57' }]}
            nodeId={panelId}
            widgetStatic={readonly}
            widgetTitle={widget.title}
          />
        )}
        {/* {!!(panelId && widgetType === "FORM") && (
          <DynamicFormContainer
            // nodes={[{ id: '56' }, { id: '57' }]}
            // nodeId={panelId}
            widgetStatic={readonly}
            widgetTitle={widget.title}
          />
        )} */}
      </CardContent>
    </Card>
  );
}

export default WidgetCard;

// TODO improve this "areEqual" check!
export const MemoizedWidgetCard = React.memo(
  WidgetCard,
  (prevProps, nextProps) => prevProps.widget === nextProps.widget
);
